// Some authentication helpers, my dudes.

const loggedIn = () => !!localStorage.token;

/**
 * Clear's the loggedIn cookie state.
 */
const clearLoggedIn = () => delete localStorage.token;

/**
 * Set the logged in cookie if they are being redirected to a valid location.
 * 
 * @param {String} route that post login will be directing them to
 */
const setLoggedIn = (route, logoutUrl) => {
  /**
   * A fully authenticated user will return a route of 'home' after
   * successfully logging in. Generate a local storage token to persist
   * data for the entirety of the user's session.
   * Or /family to handle case where non-patient members are verifying
   */
  if (route === 'home' || route === 'family') {
    localStorage.token = Math.random().toString(36).substring(7);
  }
  localStorage.logoutUrl = logoutUrl;
};

const keepAlive = () => {
  fetch('/api/session/keep-alive', {
    headers: {
      'X-Requested-With': 'Fetch',
      'Content-Type': 'application/json',
    },
    method: 'POST',
    credentials: 'include',
  });
};

export {
  clearLoggedIn,
  keepAlive,
  loggedIn,
  setLoggedIn,
};



// WEBPACK FOOTER //
// ./src/lib/auth.js